import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FaHeart,
  FaCartShopping,
  FaFacebook,
  FaWhatsapp,
} from "react-icons/fa6";

const Footer = ({ className }) => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );

  return (
    <footer className={"bg-[#f3f6fa] " + className}>
      {/* Top Section */}
      <div className="w-[85%] mx-auto border-b py-16 md:py-10 sm:py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Logo and Contact Info */}
          <div>
            <div className="flex flex-col gap-3">
              <img
                className="w-[190px] h-[70px]"
                src="https://diarcel.com/images/logo.png"
                alt="logo"
              />
              <ul className="flex flex-col gap-2 text-slate-600 text-sm">
                <li>Azacualpa Santa Barbara, Frente al Parque Municipal</li>
                <li>Teléfono: 9851 - 1183</li>
                <li>Correo: danypadillab43@gmail.com</li>
              </ul>
            </div>
          </div>

          {/* Useful Links */}
          <div>
            <h2 className="font-bold text-lg mb-3">Enlaces Útiles</h2>
            <div className="flex gap-16 lg:gap-10">
              <ul className="flex flex-col gap-2 text-slate-600 text-sm">
                <li>
                  <Link to="#">Sobre Nosotros</Link>
                </li>
                <li>
                  <Link to="#">Delivery Information</Link>
                </li>
                <li>
                  <Link to="#">Políticas de Privacidad</Link>
                </li>
              </ul>
              <ul className="flex flex-col gap-2 text-slate-600 text-sm">
                <li>
                  <Link to="#">Servicio de Reparación</Link>
                </li>
                <li>
                  <Link to="#">Tienda</Link>
                </li>
                <li>
                  <Link to="#">Noticias</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Media and Contact Section (replacing Newsletter) */}
          <div>
            <h2 className="font-bold text-lg mb-3">
              Síguenos en Redes Sociales
            </h2>
            <div className="flex flex-col gap-4">
              <p className="text-slate-600 text-sm">
                Mantente conectado con nosotros para las últimas novedades y
                ofertas especiales
              </p>
              {/* Social Media Icons */}
              <div className="flex gap-4">
                <Link
                  target="_blank"
                  to="https://www.facebook.com/profile.php?id=100063564433097"
                  className="w-10 h-10 rounded-full bg-[#059473] flex items-center justify-center text-white hover:bg-[#048063] transition-colors"
                >
                  <FaFacebook size={20} />
                </Link>
                <button className="w-10/12 py-3 bg-[#059473] text-white rounded-md hover:bg-[#048063] transition-colors flex items-center justify-center gap-2">
                  <Link
                    target="_blank"
                    to="https://www.facebook.com/profile.php?id=100063564433097"
                    className="font-semibold flex gap-2"
                  >
                    Contactar por WhatsApp
                    <FaWhatsapp size={20} />
                  </Link>
                </button>
              </div>
              {/* Contact Button */}
              <div className="mt-4"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="w-[90%] mx-auto py-5 text-center text-slate-600 text-sm">
        <span>
          © 2024 Guacamaya Design <br /> Todos los Derechos Reservados
        </span>
      </div>

      {/* Floating Action Buttons */}
      <div className="block fixed bottom-3 right-2 w-[50px] h-[110px] bg-white rounded-full p-2 shadow-lg">
        <div className="flex flex-col justify-center items-center gap-3">
          {/* Cart Icon */}
          <div
            onClick={() => navigate(userInfo ? "/card" : "/login")}
            className="relative flex justify-center items-center cursor-pointer w-9 h-9 rounded-full bg-[#e2e2e2]"
          >
            <FaCartShopping className="text-green-500 text-lg" />
            {card_product_count > 0 && (
              <div className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex justify-center items-center">
                {card_product_count}
              </div>
            )}
          </div>

          {/* Wishlist Icon */}
          <div
            onClick={() =>
              navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
            }
            className="relative flex justify-center items-center cursor-pointer w-9 h-9 rounded-full bg-[#e2e2e2]"
          >
            <FaHeart className="text-green-500 text-lg" />
            {wishlist_count > 0 && (
              <div className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex justify-center items-center">
                {wishlist_count}
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
